var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "addressForm",
      attrs: { method: "post" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("address-input-group-checkout", {
        attrs: {
          "address-type": _vm.addressType,
          "modal-type": _vm.modalType,
          value: _vm.addressData,
          "optional-address-fields": _vm.optionalAddressFields,
          "required-address-fields": _vm.requiredAddressFields,
          "default-salutation": _vm.defaultSalutation,
        },
        on: {
          input: function ($event) {
            return _vm.emitInputEvent($event)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "custom-address-fields",
              fn: function () {
                return [_vm._t("custom-address-fields")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _vm.deliveryAddressId === -99 &&
      _vm.addressType === "1" &&
      !_vm.isAddAddressEnabled
        ? _c("div", [
            _c(
              "label",
              {
                staticClass: "checkout__shipping-checkbox",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleDeliveryAddress($event)
                  },
                },
              },
              [
                _c("input", {
                  staticClass: "checkout__shipping-input",
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.isDeliveryAddressVisible },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "checkout__shipping-label" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$translate(
                          "OD3dprimaV2::Template.checkoutDifferentShipping"
                        )
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "btn btn-primary btn-appearance btn-block checkout__address-confirm",
          attrs: { type: "submit", disabled: _vm.waiting },
          on: { click: _vm.validate },
        },
        [
          _c("span", { staticClass: "d-none d-lg-inline" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.addressSet
                    ? _vm.$translate("Ceres::Template.addressSave")
                    : _vm.$translate("OD3dprimaV2::Template.addressNext")
                ) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "d-lg-none" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$translate("Ceres::Template.addressSave")) +
                "\n        "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.addressSet
        ? _c(
            "button",
            {
              staticClass:
                "btn btn-secondary btn-secondary--no-shadow btn-block",
              attrs: { type: "submit", disabled: _vm.waiting },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.emitSaved.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$translate("Ceres::Template.addressCancel")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }